import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../../ThemeContext";
import classes from "./WelcomeScreen.module.css";

const LoadingScreen = () => {
  const { theme } = useTheme();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className={classes.LoadingContainer}>
      <div className={classes.BackgroundGrid}></div>
      <div className={classes.GlowOrb}></div>
      <div className={classes.Content}>
        <motion.div
          className={classes.Logo}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className={classes.LogoInner}>J</div>
        </motion.div>
        <motion.div
          className={classes.LoaderBar}
          initial={{ width: 0 }}
          animate={{ width: "200px" }}
          transition={{ duration: 2, ease: "easeInOut" }}
        >
          <div className={classes.LoaderBarGlow}></div>
        </motion.div>
        <motion.p
          className={classes.LoadingText}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          Loading Experience...
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingScreen;
